import { render } from "./VcBlogUrlCompleteForm.vue?vue&type=template&id=6a22754d"
import script from "./VcBlogUrlCompleteForm.vue?vue&type=script&lang=js"
export * from "./VcBlogUrlCompleteForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__